import { Link } from "react-router-dom";
import { ArrowUpRight, Play } from "lucide-react";
import { mediaUrl } from "../lib/api";

export const ProjectCard = ({ project, aspect = "aspect-[4/5]", index = 0 }) => (
  <Link to={`/portfolio/${project.slug}`} className="project-card group block" data-testid={`project-card-${project.slug}`}>
    <div className={`frame relative overflow-hidden bg-sand ${aspect}`}>
      <img
        src={mediaUrl(project.cover_image)}
        alt={`${project.title} — ${project.category} ${project.label?.toLowerCase()} by BWI`}
        loading={index < 2 ? "eager" : "lazy"}
        className="h-full w-full object-cover transition-transform duration-[1400ms] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-[1.05]"
      />
      <div className="absolute inset-0 flex flex-col items-start justify-end bg-charcoal/0 p-6 opacity-0 transition-[opacity,background-color] duration-700 group-hover:bg-charcoal/45 group-hover:opacity-100 md:p-8">
        <span className="font-serif text-3xl text-ivory">{project.title}</span>
        <span className="mt-3 inline-flex items-center gap-2 text-[0.7rem] uppercase tracking-[0.25em] text-ivory">
          View Project <ArrowUpRight size={14} strokeWidth={1.25} />
        </span>
      </div>
      {(project.video_url || project.formats?.includes("Video Ads")) && (
        <span className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-ivory/85 text-wine backdrop-blur" aria-label="Contains video">
          <Play size={14} strokeWidth={1.5} className="ml-0.5" />
        </span>
      )}
    </div>
    <div className="mt-5 flex items-baseline justify-between gap-4">
      <div>
        <p className="text-[0.68rem] uppercase tracking-[0.25em] text-muted-ink">
          {project.category} <span className="mx-1.5 text-champagne">/</span> {project.label}
        </p>
        <h3 className="mt-2 font-serif text-2xl text-charcoal md:text-[1.7rem]">{project.title}</h3>
      </div>
      <span className="shrink-0 text-xs text-muted-ink">{project.year}</span>
    </div>
  </Link>
);
